<template>
  <div class="screen-wrap login-screen">
    <div class="page-outer">
      <div class="page-inner">
        <site-header />
        <page-view />
      </div>
      <div class="page-footer">
        <p>
          Copyright &copy; 2006 Leica Biosystems Imaging, Inc. All Rights Reserved
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "~lbs-pi-web-styles/dist/css/bootstrap.css";
</style>

<style lang="scss" scoped>
.screen-wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  min-height: 672px;
  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiP�dpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JhZCkiIC8+PC9zdmc+IA==);
  background-size: 100%;
  background-image: -webkit-gradient(linear, 50% 0, 50% 100%, color-stop(0px, #fff), color-stop(230px, #fff), color-stop(500px, #e8e8e9), color-stop(100%, #e8e8e9));
  background-image: -moz-linear-gradient(#fff 0, #fff 230px, #e8e8e9 500px, #e8e8e9 100%);
  background-image: -webkit-linear-gradient(#fff 0, #fff 230px, #e8e8e9 500px, #e8e8e9 100%);
  background-image: linear-gradient(#fff 0, #fff 230px, #e8e8e9 500px, #e8e8e9 100%);
  background-attachment: fixed;
}

.page-outer {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 550px;
  height: 580px;
  margin-top: -290px;
  margin-left: -250px;
}

.page-inner {
  width: 100%;
  background: #fff;
  border: 1px solid #cbcbcb;
}

.page-footer {
  margin: 103px 0 0;

  p {
    margin: 0;
    text-align: center;
    font-size: 0.8125em;
    color: #454551;
  }
}
</style>

<script>
import SiteHeader from './SiteHeader';
import PageView from './PageView';

export default {
  components: {
    SiteHeader,
    PageView
  }
};
</script>
